import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne';
import NavBar from '../nav_bar/Navbar';
import LeadEmployeeCreate from './LeadEmployeeCreate';

function LeadEmployees() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadEmployeeCreate />}
                menuId={17}
            />
        </DataContext.Provider>
    );
}

export default LeadEmployees